module.exports = __webpack_public_path__ + "static/media/art23.2ffa3059.jpg";